import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/auth/authentication";
import ToastMsg from "components/common/ToastMsg";

const useApiWrapper = () => {
    const navigate = useNavigate();
    const { logoutauth } = useContext(AuthContext);

    const apiWrapper = async (apiCall, setLoading = () => {}) => {
        try {
            setLoading(true);

            const response = await apiCall();

            // Handle specific response details
            if (response.detail) {
                if (response.detail === "You are not authorized to perform this action") {
                    navigate("/");
                    logoutauth();
                } else if (response.detail === "You are attempting to log in without an active subscription. Please subscribe to a plan to access the system.") {
                    ToastMsg('error', response.detail);
                    navigate("/myplans");
                }
            }
            
            return response;
        } catch (error) {
            // Handle API errors
            // ToastMsg('error', error.message || "An unexpected error occurred");
            console.log(error);
            
        } finally {
            setLoading(false); // Ensure loading is stopped
        }
    };

    return { apiWrapper };
};

export default useApiWrapper;
